import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import classnames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import langIsEn from '../../utils/langIsEn';
import styles from './ContentCarousel.css';

const autoplaySpeed = 3500;

class ContentCarousel extends Component {
  static propTypes = {
    pic: PropTypes.object.isRequired,
  };

  state = {
    isVisible: false,
    timeoutID: null,
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.isVisible && !this.state.timeoutID) {
      const timeoutID = setTimeout(() => {
        if (this.refs.slider) {
          this.refs.slider.slickGoTo(1);
        }
      }, autoplaySpeed);
      this.setState({ timeoutID: timeoutID });
    }
  }

  componentWillUnmount() {
    const { timeoutID } = this.state;
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  }

  onChange(isVisible) {
    if (!this.state.isVisible && isVisible) {
      this.setState({
        isVisible: isVisible,
      });
    }
  }

  render() {
    const { pic } = this.props;
    const { engTitle, chtTitle, engContent, chtContent } = pic;
    let title = null, content = null;
    const settings = {
      dots: true,
      autoplay: true,
      autoplaySpeed: autoplaySpeed,
    };
    const slides = pic.attachments.map((attachment, idx) =>
      <div className={styles.img} key={idx}>
        <img className={styles.content} src={attachment.url} alt={pic.engTitle} />
      </div>
    );
    const { isVisible } = this.state;

    if (langIsEn()) {
      title = engTitle;
      content = engContent;
    } else {
      title = chtTitle;
      content = chtContent;
    }

    return (
      <div className={classnames(styles.contentCarousel, { 'animated fadeInUp': isVisible })}>
        {(title || content) &&
          <div className={classnames(
            styles.detailBlock,
            { [styles.chtDetailBlock]: !langIsEn() }
          )}>
            {title && <p className={styles.title}>{title}</p>}
            {content && <p className={styles.content}>{content}</p>}
          </div>
        }
        <VisibilitySensor
          onChange={this.onChange.bind(this)}
          partialVisibility={true}
        >
          <Slider ref="slider" {...settings}>
            {slides}
          </Slider>
        </VisibilitySensor>
      </div>
    );
  }
}

export default ContentCarousel;



// WEBPACK FOOTER //
// ./src/components/content-carousel/ContentCarousel.js